export const priceBook = {
  basePerSquareMeter: 4800,
  profiles: {
    slim: 5200,
    quadro: 6100,
    wide: 6800,
  },
  colors: {
    snow: {
      slim: 1050,
      quadro: 550,
      wide: 550,
    },
    warm: {
      slim: 1100,
      quadro: 600,
      wide: 600,
    },
    graphite: {
      slim: 1000,
      quadro: 500,
      wide: 500,
    },
    bronze: {
      slim: 1100,
      quadro: 600,
      wide: 600,
    },
  },
  accessories: {
    sealantPerMeter: 50,
    cornerPerPiece: 100,
    cornerPiecesIncluded: 4,
  },
  milling: {
    hinge: {
      slim: 100,
      quadro: 250,
      wide: 250,
    },
    weights: 100,
  },
  hinges: {
    softClose: 250,
    regular: 220,
    client: 0,
  },
  fillings: {
    clearGlass: 1380,
    ultraClear: 730,
    graphiteGlass: 1750,
    bronzeGlass: 1600,
    mirrorSilver: 1410,

  },
};

